<template>
  <template v-if="!isMobile()">
    <div class="available-on">
      <div class="container">
        <div class="divider-line p-3 d-block"></div>

        <h1 class="text-center p-3">{{ $t("landing.promo.title") }}</h1>

        <div class="row separated">
          <div class="col-sm-6 watch-on-tv">
            <h1 class="promo-title">{{ $t("landing.promo.whatch_on_tv") }}</h1>
            <img src="@/assets/img/icons/small-divider.svg" alt="divider" />
            <p class="promo-text">
              {{ $t("landing.promo.whatch_on_tv_desc") }}
            </p>
          </div>
          <div class="col-sm-6 text-center side-image">
            <img :src="imgUrl('/img/tv-thumbnail.png')" alt="tv-thumbnail" />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 text-center side-image">
            <img :src="imgUrl('/img/promo-phone.png')" alt="mobile-thumbnail" />
          </div>
          <div class="col-sm-6 watch-on-mobile">
            <h1 class="promo-title">{{ $t("landing.promo.use_our_app") }}</h1>
            <img src="@/assets/img/icons/small-divider.svg" alt="divider" />
            <p class="promo-text">{{ $t("landing.promo.use_our_app_desc") }}</p>

            <div class="stores">
              <a
                href="https://itunes.apple.com/us/app/flixlatino-go/id1113757930?mt=8"
                target="_blank"
              >
                <img :src="imgUrl('/img/app-store.png')" alt="app-store" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.trespixels.flixlatino"
                target="_blank"
              >
                <img :src="imgUrl('/img/play-store.png')" alt="play-store" />
              </a>
            </div>
          </div>
        </div>
        <div class="clear">&nbsp;</div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="container available-on-mobile">
      <div class="divider-line mb-5 pb-3 d-block"></div>
      <h1 class="text-center p-3">{{ $t("landing.promo.title") }}</h1>

      <div class="mx-3">
        <img
          :src="imgUrl('/img/tv-thumbnail.png')"
          alt="tv-thumbnail"
          class="tv-thumbnail"
        />
        <h2 class="promo-title">{{ $t("landing.promo.whatch_on_tv") }}</h2>
        <p class="promo-text">{{ $t("landing.promo.whatch_on_tv_desc") }}</p>

        <img
          :src="imgUrl('/img/promo-phone.png')"
          alt="mobile-thumbnail"
          class="tv-thumbnail"
        />
        <h2 class="promo-title">{{ $t("landing.promo.use_our_app") }}</h2>
        <p class="promo-text">{{ $t("landing.promo.use_our_app_desc") }}</p>

        <div class="stores">
          <a
            href="https://itunes.apple.com/us/app/flixlatino-go/id1113757930?mt=8"
            target="_blank"
          >
            <img :src="imgUrl('/img/app-store.png')" alt="app-store" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.trespixels.flixlatino"
            target="_blank"
          >
            <img :src="imgUrl('/img/play-store.png')" alt="play-store" />
          </a>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
export default {
  name: "AvailableOn",
};
</script>

<style lang="scss">
@import "src/assets/scss/colors";
.available-on-mobile {
  .tv-thumbnail {
    margin: 0.5em 0;
  }
  .promo-title {
    margin: 1em 0;
    font-weight: normal;
  }
  .promo-text {
    color: $gray-3;
    font-weight: 300;
  }
  .stores {
    text-align: center;
    margin-bottom: 3em;
    img {
      height: 48px;
      margin-right: 1em;
    }
  }
}
.available-on {
  background: linear-gradient(
    356.13deg,
    rgba(20, 28, 45, 0.3) -13.92%,
    rgba(19, 28, 45, 0.3) 121.92%
  );
  .separated {
    margin: 10em 0;
  }
  .watch-on-tv {
    padding-top: 6em;
  }
  .watch-on-mobile {
    padding-top: 9em;
  }
  .stores {
    img {
      height: 3em;
      margin-right: 1em;
    }
  }
  .promo-text {
    color: $gray-2;
    margin-bottom: 2em;
  }

  .side-image{
    img{
      width: 90%;
      height: auto;
    }
  }
  h1{
    font-size: 2.5em;
  }
  @media (max-width: 767px) {
    .separated {
      margin: 0 0 3em;
    }

    .watch-on-mobile {
      padding-top: 0em;
    }
  }
  @media (min-width: 1920px) {
    font-size: 0.8vw;
    .container{
      width: 75%;
      max-width: none;
    }
  }
  
}
</style>
